export default __webpack_public_path__ + "static/media/warloc_outreach.3599dae2.svg";